module.exports = __webpack_public_path__ + "img/pasos1-1.f23107cc.png";